import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import ImageGallery from 'react-image-gallery';
import {
  Box,
  Paper,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  FormLabel,
  TextareaAutosize,
  Alert,
  Checkbox,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  Grid,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FileUpload from "./FileUploadBox.tsx";
import { FieldError } from "../../ScoreCardValidation/ValidationErrors.tsx";
import type { ValidationError } from "../../ScoreCardValidation/ValidationSchema.tsx";
import { AddAPhotoOutlined, AddComment, AddToPhotosOutlined, AutoAwesome, CancelOutlined, CloseOutlined, ContentCopyOutlined, DescriptionOutlined, Error, ErrorOutline, ErrorOutlined, Help, HistoryOutlined, ReportProblemOutlined } from "@mui/icons-material";
import CropperModal from "../../CropModel/CropperModal.tsx";
import { ApiGetReportHistory, ApiUpdateReportQuestion } from "../../../apiService/Core/CustomApiScoreCards.tsx";
import { toast } from "react-toastify";
import VoiceInputDialog, { MicButton } from "./Voiceinputdialog.tsx";

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "1px dashed",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

const UploadIconBox = styled(Box)(({ theme }) => ({
  width: "48px",
  height: "48px",
  border: "1px solid",
  borderColor: theme.palette.divider,
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(1),
}));

interface QuestionItemProps {
  questionsData: any;
  question: any;
  ref: any;
  index: number;
  clientGroup: string;
  uniqueCategories: any;
  answers: Record<string, any>;
  setAnswer: any;
  reportOtherDetails: any;
  setUploadedFiles: any;
  oldmaxScore: any
  reorderFile: (section: any, from: any, to: any, questionId: any) => void;
  uploadedFiles: any;
  onAnswerChange: (questionId: any, value: any) => void;
  onCommentChange: (questionId: any, comment: string) => void;
  onFileUpload: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    questionId?: number,
    reportDetailId?: number

  ) => void;
  onFileUpdate: (
    event: React.ChangeEvent<HTMLInputElement>,
    section: string,
    questionId?: number,
    reportDetailId?: number

  ) => void;
  onRemoveFile: (section: string, index: number) => void;
  validationErrors?: ValidationError[];
  setArchieveImages: () => void
  AiReviews: any
}

// Add a validation function to check if the required number of images are uploaded
const validateImageUploads = (
  optionImage: number,
  uploadedFiles: string[] | undefined
): boolean => {
  if (optionImage < 0) return true; // No images required
  if (!uploadedFiles || uploadedFiles.length < optionImage) return false;
  return true;
};

// Add this inside the QuestionItem component, after the options parsing
const getImageValidationMessage = (optionImage: number): string => {
  return `This answer requires minimum ${optionImage} image${optionImage > 1 ? "s" : ""
    }.`;
};

const validateTextFieldCharacter = (question: any) => {
  if (question.minChar <= 0) return true;
};

const ALDIQuestionItem: React.FC<QuestionItemProps> = ({
  questionsData,
  question,
  index,
  clientGroup,
  answers,
  reportOtherDetails,
  setAnswer,
  ref,
  setUploadedFiles,
  reorderFile,
  uploadedFiles,
  uniqueCategories,
  onAnswerChange,
  onCommentChange,
  onFileUpload,
  onFileUpdate,
  onRemoveFile,
  validationErrors = [],
  setArchieveImages,
  oldmaxScore,
  AiReviews
}) => {

  // State to store the full response object for each question
  const [responseData, setResponseData] = useState<any>({
    questionId: question.questionId,
    reportDtlId: question.reportDtlId,
    value: answers[question.questionId]?.value || "",
    photoUrl: answers[question.questionId]?.photoUrl || "",
    score: answers[question.questionId]?.score !== null ?
      answers[question.questionId]?.score
      : null,
    comment: answers[question.questionId]?.comment || "",
    isAnswered: answers[question.questionId]?.isAnswered ?? false, // Default to false
    optionImage:
      JSON.parse(question.qOptionJson || "[]").find(
        (opt: any) =>
          opt.value === (answers[question.questionId]?.value || question.value)
      )?.optionImage || 0,
  });
  let options = [];

  if (question.questionId === 32107) {
  }
  // const [cropperOpen, setCropperOpen] = useState<boolean>(false)
  // const [cropperFile, setCropperFile] = useState<any>('')
  const [bigImg, setbigImg] = useState<boolean>(false)
  const [showImg, setshowImg] = useState<any>([])
  const [showimagebox, setshowimagebox] = useState<boolean>(false)
  const [localComment, setLocalComment] = useState(responseData.comment || "");
  const [showcommentbox, setshowcommentbox] = useState<boolean>(false)
  const isAdmin = localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor'
  const [resportHistory, setReportHistory] = useState<any>(null)
  const [openHistory, setOpenHistory] = useState<boolean>(false)
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);
  const [voiceTarget, setVoiceTarget] = useState<null | "answer" | "comment">(null);



  const images = showImg && showImg.map(img => ({
    original: img,
    thumbnail: img,
  }));

  const callfunction = localStorage.getItem('iap')
  useEffect(() => {
    // Only initialize if the files aren't already in the state
    if (
      callfunction
    ) {
      const photoUrlToUse =
        answers[question.questionId]?.photoUrl || question.photoUrl || "";
      const fileArray = photoUrlToUse
        .split(",")
        .map((str) => str.trim())
        .filter(Boolean);

      if (fileArray.length > 0) {
        setUploadedFiles((prevState: any) => ({
          ...prevState,
          questionFiles: {
            ...prevState.questionFiles,
            [question.questionId]: fileArray,
          },
        }));

        // Also update the answers state to ensure consistency
        if (!answers[question.questionId]?.photoUrl && fileArray.length > 0) {
          onAnswerChange(question.questionId, {
            reportDtlId: question.reportDtlId,
            questionId: question.questionId,
            value: responseData.value,
            photoUrl: fileArray.join(","),
            score: responseData.score,
            comment: responseData.comment || question.comment || "",
          });
        }
      }
      localStorage.removeItem('iap')
    }
  }, [callfunction]);
  // setUploadedFiles((prevState: any) => {
  //   const fileArray = question.photoUrl
  //     ?.split(",")
  //     .map((str) => str.trim())
  //     .filter(Boolean) || [];

  //   return {
  //     ...prevState,
  //     questionFiles: {
  //       ...prevState.questionFiles,
  //       [question.questionId]: fileArray,
  //     },
  //   };
  // });

  // useEffect(() => {
  //   if (questionsData) {
  //     setAnswer(
  //       questionsData.questions.reduce((acc, question) => {
  //         return {
  //           ...acc,
  //           [question.questionId]: {
  //             reportDtlId: question.reportDtlId,
  //             value: question.value || "",
  //             photoUrl: question.photoUrl || "",
  //             score: question.score || 0,
  //             comment: question.comment || "",
  //             isAnswered: question.isAnswered || false,
  //           },
  //         };
  //       }, {})
  //     );
  //   }
  // }, [questionsData]);

  useEffect(() => {
    // Update isAnswered based on the presence of a comment
    const currentFiles = uploadedFiles.questionFiles[question.questionId] || [];
    const isImageValid = validateImageUploads(
      responseData.optionImage,
      currentFiles
    );

    setResponseData((prevData) => ({
      ...prevData,
      photoUrl: answers[question.questionId]?.photoUrl,
      isAnswered: responseData?.value !== "",
      isImageValid: isImageValid,
    }));

    // Update the answer with the validation status
    if (responseData.value) {
      onAnswerChange(question.questionId, {
        ...answers[question.questionId],
        isImageValid: isImageValid,
      });
    }
  }, [
    uploadedFiles,
    question.questionId,
    responseData.comment,
    responseData.optionImage,
  ]);


  const handleCommentChange = useCallback((newComment: string) => {
    setLocalComment(newComment); // update local instantly
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {

      onAnswerChange(question.questionId, {
        reportDtlId: question.reportDtlId,
        value: responseData.value,
        questionId: responseData.questionId,
        photoUrl: responseData.photoUrl,
        score: responseData.score,
        comment: localComment,
        isAnswered: responseData.value !== "",
      });

      setResponseData((prevData) => ({
        ...prevData,
        comment: localComment,
      }));
    }, 1000); // debounce delay

    return () => clearTimeout(handler);
  }, [localComment]);

  // Handle changes in other fields (like radio button selection)
  const handleFieldChange = (newValue: string) => {
    const selectedOption: any = options.find((opt: any) => opt.value?.trim() === newValue?.trim());

    if (selectedOption) {
      const optionImage = selectedOption.optionImage || 0;
      const currentUploadedFiles =
        uploadedFiles.questionFiles[question.questionId] || [];
      const isImageValid = validateImageUploads(
        optionImage,
        currentUploadedFiles
      );

      setResponseData((prevData) => ({
        ...prevData,
        value: selectedOption.value,
        // score: selectedOption.optionScore !== -1 ? Number(((parseFloat(selectedOption.optionScore) / 100) * (question.oldMaxScore))) || 0 : parseInt(selectedOption.optionScore),
        score: selectedOption.optionScore !== -1
          ? (() => {
            const val = Number(((parseFloat(selectedOption.optionScore) / 100) * question.oldMaxScore)) || 0;
            return question.oldMaxScore % 1 === 0 ? Math.round(val) : Number(val.toFixed(2));
          })()
          : parseInt(selectedOption.optionScore),
        maxScore: selectedOption.optionScore === -1 ? 0 : oldmaxScore[question.questionId]?.oldMaxScore != null ? oldmaxScore[question.questionId]?.oldMaxScore : question.maxScore,
        optionImage: optionImage,
        isImageValid: isImageValid,
      }));

      const updateddata = {
        reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
        reportDtlId: question.reportDtlId,
        value: selectedOption.value,
        platform: "web",
        platformAppType: null,
        photoUrl: responseData.photoUrl,
        score: selectedOption.optionScore !== -1
          ? (() => {
            const val = Number(((parseFloat(selectedOption.optionScore) / 100) * question.oldMaxScore)) || 0;
            return question.oldMaxScore % 1 === 0 ? Math.round(val) : Number(val.toFixed(2));
          })()
          : parseInt(selectedOption.optionScore),
        comment: responseData.comment,
        isAnswered: selectedOption.value?.length > 0,
        // editorComment,
        maxScore: selectedOption.optionScore == -1 ? 0 : oldmaxScore[question.questionId]?.oldMaxScore != null ? oldmaxScore[question.questionId]?.oldMaxScore : question.maxScore
      }

      updateQuestion(updateddata)

      onAnswerChange(question.questionId, {
        reportDtlId: question.reportDtlId,
        value: selectedOption.value,
        questionId: question.questionId,
        optionId: selectedOption.optionId,
        photoUrl: responseData.photoUrl,
        // score: selectedOption.optionScore !== -1 ? Number(((parseInt(selectedOption.optionScore) / 100) * (question.oldMaxScore))) || 0 : parseInt(selectedOption.optionScore),
        score: selectedOption.optionScore !== -1
          ? (() => {
            const val = Number(((parseFloat(selectedOption.optionScore) / 100) * question.oldMaxScore)) || 0;
            return question.oldMaxScore % 1 === 0 ? Math.round(val) : Number(val.toFixed(2));
          })()
          : parseInt(selectedOption.optionScore),
        maxScore: selectedOption.optionScore == -1 ? 0 : oldmaxScore[question.questionId]?.oldMaxScore != null ? oldmaxScore[question.questionId]?.oldMaxScore : question.maxScore,
        comment: responseData.comment,
        isAnswered: selectedOption.value?.length > 0,
        optionImage: optionImage,
        isImageValid: isImageValid,
      });
    }
  };

  let bgColor = "#e8f5e9"; // Default green
  if (question.score > 0) {
    bgColor = "#fff9c4"; // Yellow for scoring questions
  }
  if (question.qType === "T") {
    bgColor = "#f8bbd0"; // Pink for text questions
  }

  try {
    options = JSON.parse(question.qOptionJson || "[]"); // Safely parse JSON
    if (question.questionId === 51) {
    }
  } catch (error) {
    console.error("Invalid JSON in question.qOptionJson:", error);
  }

  const [prevCommentType, setPrevCommentType] = useState<string | null>(null);

  useEffect(() => {
    const selectedOption: any = options.find(
      (opt: any) => opt.value === responseData.value
    );

    const currentCommentType = selectedOption?.optionCommentType || "text";

    if (selectedOption?.optionComment === "yes") {
      if (prevCommentType && prevCommentType !== currentCommentType) {
        handleCommentChange(""); // Reset when type changes
      }
      setPrevCommentType(currentCommentType);
    }
  }, [responseData.value, options]);

  const bgcolor = (categoryName: string) => {
    const randomColors = [
      'rgb(195,148,223)',
      'rgb(193,238,219)',
      'rgb(244,185,194)',
      'rgb(168,186,228)',
      'rgb(154,198,178)',
      'rgb(211,213,142)',
      'rgb(220,201,242)',
      'rgb(172,132,238)',
      'rgb(149,190,214)',
      'rgb(246,238,226)',
      'rgb(130,128,132)',
      'rgb(240,202,151)',
    ];

    const index = uniqueCategories.indexOf(categoryName);

    if (index === -1) return '#ffffff';

    // Loop colors using modulo
    return randomColors[index % randomColors.length];
  };


  const [localValue, setLocalValue] = useState(responseData.value || "");


  // Debounce sync to parent
  useEffect(() => {
    const handler = setTimeout(() => {
      // if ((localValue || "") !== (responseData.value || "")) {
      setResponseData((prevData) => ({
        ...prevData,
        value: localValue,
      }))
      onAnswerChange(question.questionId, {
        reportDtlId: question.reportDtlId,
        value: localValue,
        questionId: question.questionId,
        photoUrl: responseData.photoUrl,
        score: responseData.score,
        comment: responseData.comment,
        isAnswered: localValue.trim().length > 0,
      });
      // }
    }, 500); // only update parent after 0.5s of no typing

    return () => clearTimeout(handler);
  }, [localValue]); // only depend on typing

  const handleChange = useCallback((e: any) => {
    setLocalValue(e.target.value); // instant UI update
  }, []);


  const updateQuestion = async (data: any) => {
    try {
      const res = await ApiUpdateReportQuestion(data, clientGroup)
    } catch (error: any) {
      toast.error("Error while saving question")
      console.log("Error ON Blur Save ", error.message)
    }
  }

  const isIssue = AiReviews?.questionIssues?.find(
    (issue: any) => issue.reportDtlId === question?.reportDtlId
  );

  const getHistory = async (data: any) => {
    try {
      const res = await ApiGetReportHistory(data, clientGroup)
      if (res?.status) {
        setReportHistory(res?.data)
        setOpenHistory(true)
      }
    } catch (error: any) {
      toast.error(error?.message)
    }
  }


  const applyVoiceText = (target: "answer" | "comment", text: string) => {
    const base = {
      reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
      platform: "web",
      platformAppType: null,
      reportDtlId: question.reportDtlId,
      photoUrl: responseData.photoUrl,
      score: responseData.score,
      maxScore: responseData.maxScore,
    };
    if (target === "answer") {
      setLocalValue(text); // existing 500ms debounce syncs to parent
      updateQuestion({ ...base, value: text, comment: responseData.comment, isAnswered: text.trim().length > 0 });
    } else {
      setLocalComment(text); // existing 1s debounce syncs to parent
      updateQuestion({ ...base, value: responseData.value, comment: text, isAnswered: responseData.value !== "" });
    }
  };


  return (
    <Paper
      component="div"
      ref={ref}
      className={isIssue ? 'blink-border' : ''}
      sx={{
        backgroundColor: "transparent",
        p: { xs: 2, md: 3 },
        borderRadius: "10px",
        margin: '20px 0px !important',
        border: validationErrors.some(
          (e) => e.field === `question_${question.questionId}`
        ) ? '2px solid red' : "",
        position: 'relative',
        bgcolor: bgcolor(question?.categoryName),


        // border: 


      }}
      data-field={`question_${question.questionId}`}

    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          alignItems: "flex-start",
        }}

      >
        <Typography className="px-3 py-1 fs-14" borderRadius='5px' color="white" bgcolor='darkblue' position='absolute' top='-20px' left='10px' fontWeight='bold'>{question?.categoryName}</Typography>

        {(localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor') && (
          <Box className='d-flex align-items-center gap-2' position='absolute' top='-20px' right='10px'>
            {isIssue && (
              <Tooltip
                arrow
                placement="left-start"
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxWidth: '700px',
                      width: '100%',
                      bgcolor: '#fff',
                      color: '#000',
                      boxShadow: '0px 4px 20px rgba(0,0,0,0.15)',
                      borderRadius: '12px',
                      p: 2
                    }
                  },
                  arrow: {
                    sx: {
                      color: '#fff'
                    }
                  }
                }}
                title={
                  <Box className='mb-2' width={'100%'} maxWidth={'700px'} sx={{ cursor: 'pointer' }}>
                    <Box className='d-flex align-items-center mb-1' gap={'10px'}>
                      <Box flex={1}>
                        <Typography variant="body2" className="fw-bold bg-danger text-white px-2 py-1 border-10" width={'fit-content'}>{question?.displayOrder}.Question</Typography>
                        <Typography className="fw-bold fs-14" gutterBottom>{isIssue?.questionLabel}</Typography>
                      </Box>
                    </Box>
                    <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#BF613B2A'}>
                      <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                        <ReportProblemOutlined sx={{ fontSize: '35px', fill: "#BF613B !important" }} />
                        <Box>
                          <Typography variant="body2" className="fw-bold" color="#BF613B">Issue</Typography>
                          <Typography className="fs-12">{isIssue?.issue}</Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Grid container className="p-3 mb-3 border-10" justifyContent={'space-between'} bgcolor={'#7C9FB22A'}>
                      <Grid xs={12} className="d-flex align-items-start" gap={'20px'}>
                        <DescriptionOutlined sx={{ fontSize: '35px', fill: "#7C9FB2 !important" }} />
                        <Box>
                          <Typography variant="body2" className="fw-bold">Description</Typography>
                          <Typography className="fs-12">{isIssue?.description}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                }
              >
                <Box bgcolor='darkblue' className="p-0 border-10">
                  <IconButton><AutoAwesome sx={{ fill: "white !important" }} /></IconButton></Box>
              </Tooltip>)}
            <Tooltip title='Add images'><Box bgcolor='darkblue' onClick={() => { setshowimagebox(!showimagebox) }} className="p-0 border-10"><IconButton><AddToPhotosOutlined sx={{ fill: 'white !important' }} /></IconButton></Box></Tooltip>
            <Tooltip title='Add comment'><Box bgcolor='darkblue' onClick={() => { setshowcommentbox(!showcommentbox) }} className="p-0 border-10"><IconButton><AddComment sx={{ fill: 'white !important' }} /></IconButton></Box></Tooltip>
            <Tooltip title='see history'>
              <Box bgcolor='darkblue' sx={{ cursor: "pointer" }} padding={'6px'} className="border-10" onClick={() => { getHistory(`?reportHeaderId=${questionsData?.reportHeader?.reportHeaderId}&reportDtlId=${question?.reportDtlId}`) }}>
                <HistoryOutlined sx={{ fill: 'white !important', fontSize: "28px" }} />
              </Box>
            </Tooltip>
          </Box>
        )}
        {/* <Typography className="px-3 py-1" borderRadius='5px' variant="body1" color="white" bgcolor='darkblue' fontWeight='bold'>{question?.categoryName}</Typography> */}
        <Box
          className='w-100'
          sx={{ display: "flex", alignItems: "flex-start" }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              fontSize: "15px",
              color: "#333",
              bgcolor: 'white',
              mr: 1,
              px: 2,
              // py:1,
              borderRadius: 1
            }}
          >
            {question.questionLabel
              ? `${question.questionLabel}.`
              : `${index + 1}.`}
          </Typography>

          <Typography
            // variant="subtitle1"
            className="fs-16"
            sx={{
              // fontSize: "15px",
              fontWeight: "bold",
              color: "#333",

              wordBreak: "break-word",
              whiteSpace: "pre-wrap",
              flex: 1,
            }}
          >
            <span dangerouslySetInnerHTML={{ __html: question.questions }} />
          </Typography>
        </Box>
      </Box>
      {/* Unified Score display box */}

      <Box className="scorecardContent p-1 p-lg-2 px-lg-4 border-10" sx={{ float: "left", width: { xs: "100%", md: "85%" }, backgroundColor: "#ffcc9d", }}>
        {question.questionDescription?.trim().length > 0 && (
          <Box
            className='fs-14'
            sx={{
              mb: 2,

              // borderLeft: "4px solid #a29b66", 
              padding: "8px 12px",
              borderRadius: "4px",
              // fontSize: "14px",
              color: "#001e78", // default text color matching the inline styles
            }}
            dangerouslySetInnerHTML={{ __html: question.questionDescription }}
          />
        )}

        {question.questionHint?.trim().length > 0 &&

          (
            <Box display="flex" alignItems="center" mb={2}>
              {/* <Box
                  sx={{
                    backgroundColor: "#a29b66", // Olive background
                    color: "white",
                    fontWeight: "bold",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                    marginRight: "8px",
                  }}
                >

                  Hint:
                </Box> */}

              <Typography
                className="fs-16"
                sx={{
                  // backgroundColor: "#ffffff",
                  // color
                  borderRadius: "4px",
                  padding: "4px 8px",
                }}
                dangerouslySetInnerHTML={{ __html: question.questionHint }}
              // variant="body1"

              />
            </Box>
          )}
        {question.questionHintImages?.trim().length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              mb: 2,
              mt: -1, // pull closer to the description if needed
            }}
          >
            {question.questionHintImages
              .split(",")
              .map((src: string, index: number) => (
                <img
                  key={index}
                  src={src.trim()}
                  onClick={() => { setshowImg(question.questionHintImages.split(',')); setbigImg(true) }}
                  alt={`Hint ${index + 1}`}
                  style={{
                    maxHeight: "120px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                  }}
                />
              ))}
          </Box>
        )}


        {/* Radio buttons for question type R */}
        {question.qType === "R" && (
          <FormControl
            component="fieldset"
            error={validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            )}
            sx={{ width: "100%" }}
          >
            <RadioGroup
              row
              value={responseData.value?.trim() || ""}
              onChange={(e) => handleFieldChange(e.target.value)}
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: 1,
                "& .MuiFormControlLabel-root": {
                  margin: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  mb: 1,
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                },
                "& .Mui-checked + .MuiFormControlLabel-label": {
                  fontWeight: "bold",
                },
              }}
            >
              {options
                ?.filter((option: any) => {
                  // if visibleToEditorOnly is true → only admin can see
                  if (option?.visibleToEditorOnly) {
                    return isAdmin;
                  }
                  // otherwise visible to all
                  return true;
                })
                ?.map((option: any) => (
                  <FormControlLabel
                    key={option.optionId}
                    value={option.value?.trim()}
                    control={
                      <Radio
                        sx={{
                          color: "#aaa",
                          fill: '#7C9FB2',
                          "&.Mui-checked": {
                            fill: '#7C9FB2'
                          },
                        }}
                      />
                    }
                    label={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: `${option.value?.replace(/<\/?p>/g, "")}`,
                        }}
                        className="fs-14"
                      // sx={{ fontSize:{xs:"12px",sm:"14px"} }}
                      />
                    }
                  />
                ))}
            </RadioGroup>
            {validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
              <FieldError

                errors={validationErrors}
                field={`question_${question.questionId}`}
              /></Box>
              )}
          </FormControl>
        )}

        {/* Text area for question type T */}
        {question.qType === "T" && (
          <div>
            <TextareaAutosize
              minRows={3}
              placeholder="Write here..."
              // value={responseData.value || ""}
              // onChange={(e) => {
              //   const newValue = e.target.value;

              //   setResponseData((prevData) => ({
              //     ...prevData,
              //     value: newValue,
              //   }));

              //   onAnswerChange(question.questionId, {
              //     reportDtlId: question.reportDtlId,
              //     value: newValue,
              //     questionId: question.quetionId,
              //     photoUrl: responseData.photoUrl,
              //     score: responseData.score,
              //     comment: responseData.comment,
              //     isAnswered: newValue.length > 0,
              //   });
              // }}
              value={localValue}
              onChange={handleChange}
              onBlur={(e) => {
                const updateddata = {

                  reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                  reportDtlId: question.reportDtlId,
                  value: e.target.value,
                  photoUrl: responseData.photoUrl,
                  score: responseData.score,
                  comment: responseData.comment,
                  isAnswered: e.target.value.trim().length > 0,
                  maxScore: responseData.maxScore
                }

                updateQuestion(updateddata)
              }}
              className={`textarea-custom ${validationErrors.some(
                (e) => e.field === `question_${question.questionId}`
              )
                ? "error-border"
                : ""
                }`}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ddd",
                fontSize: "14px",
                backgroundColor: "#fff",
                resize: "vertical",
                //minHeight: "100px",
                borderColor: validationErrors.some(
                  (e) => e.field === `question_${question.questionId}`
                )
                  ? "#d32f2f"
                  : "#ddd",
              }}
            />

            <MicButton
              onClick={() => setVoiceTarget("answer")}
              sx={{ position: "absolute", top: isAdmin ? 30 : 8 , right: 8 }}
            />
            {/* Alert for minChar validation */}
            {/* {question.minChar > 0 &&
              (responseData.value?.trim().split(/\s+/).length < question.minChar) && (
                <Alert severity="error" sx={{ mt: 2, mb: 1 }}>
                  Minimum {question.minChar} words required.
                </Alert>
              )} */}
            {validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
              <FieldError
                errors={validationErrors}
                field={`question_${question.questionId}`}
              />
            </Box>)}
          </div>
        )}

        {/* Rating scale for question type r */}
        {question.qType === "r" && (
          <FormControl
            component="fieldset"
            error={validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            )}
            sx={{ width: "100%", mt: 2 }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  p: 2,
                  border: "1px solid #ddd",
                }}
              >
                <RadioGroup
                  row
                  value={responseData.value || ""}
                  onChange={(e) => handleFieldChange(e.target.value)}
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  {options?.filter((option: any) => {
                    // if visibleToEditorOnly is true → only admin can see
                    if (option?.visibleToEditorOnly) {
                      return isAdmin;
                    }
                    // otherwise visible to all
                    return true;
                  })?.map((option: any, idx: number) => (
                    <Box className='d-flex flex-column justify-content-center align-items-center' gap={'3px'}>
                      <FormControlLabel
                        key={option.optionId}
                        value={option.value}
                        control={
                          <Radio
                            sx={{
                              color: "#aaa",
                              "&.Mui-checked": {
                                color: "#7C9FB2 !important",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: 24,
                                fill: "#7C9FB2 !important"
                              },
                            }}
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: "500",
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                          >
                            {option.value}
                          </Typography>
                        }
                        labelPlacement="bottom"
                        sx={{
                          margin: 0,
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      />
                      <Typography
                        variant="caption"
                        className="text-center"
                        sx={{
                          color: "#666",
                          fontSize: "12px",
                        }}
                      >
                        {option?.radioRatingComment || ""}
                      </Typography>
                    </Box>
                  ))}
                </RadioGroup>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 1,
                    px: 1,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#666",
                      fontSize: "12px",
                      maxWidth: "30%",
                    }}
                  >
                    {options[0]?.radioRatingComment || ""}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#666",
                      fontSize: "12px",
                      textAlign: "center",
                    }}
                  >
                    {options[4]?.radioRatingComment || ""}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#666",
                      fontSize: "12px",
                      textAlign: "right",
                      maxWidth: "30%",
                    }}
                  >
                    {options[9]?.radioRatingComment || ""}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
              <FieldError
                errors={validationErrors}
                field={`question_${question.questionId}`}
              />
            </Box>)}
          </FormControl>
        )}

        {/* Checkboxes for question type C */}
        {question.qType === "C" && (
          <FormControl
            component="fieldset"
            error={validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            )}
            sx={{ width: "100%" }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: 2,
                mt: 2,
              }}
            >
              {options
                ?.filter((option: any) => {
                  // if visibleToEditorOnly is true → only admin can see
                  if (option?.visibleToEditorOnly) {
                    return isAdmin;
                  }
                  // otherwise visible to all
                  return true;
                })?.map((option: any) => (
                  <Box
                    key={option.optionId}
                    sx={{
                      backgroundColor: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={(responseData.value || "")
                            .split(",")
                            .includes(option.value)}
                          onChange={(e) => {
                            const currentValues = (responseData.value || "")
                              .split(",")
                              .filter(Boolean);
                            let newValues;
                            if (e.target.checked) {
                              newValues = [...currentValues, option.value];
                            } else {
                              newValues = currentValues.filter(
                                (val) => val !== option.value
                              );
                            }
                            const newValueString = newValues.join(",");
                            setResponseData((prevData) => ({
                              ...prevData,
                              value: newValueString,
                              score: newValueString?.length > 0 ? question.score ?? question.maxScore : ''
                            }));

                            onAnswerChange(question.questionId, {
                              reportDtlId: question.reportDtlId,
                              value: newValueString,
                              questionId: question.questionId,
                              photoUrl: responseData.photoUrl,
                              score: newValueString?.length > 0 ? question.score ?? question.maxScore : '',
                              comment: responseData.comment,
                              isAnswered: newValues.length > 0,
                            });

                            const updateddata = {
                              reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                              reportDtlId: question.reportDtlId,
                              value: newValueString,
                              photoUrl: responseData.photoUrl,
                              score: newValueString?.length > 0 ? question.score ?? question.maxScore : '',
                              comment: responseData.comment,
                              isAnswered: newValues.length > 0,
                              maxScore: responseData.maxScore
                            }

                            updateQuestion(updateddata)

                          }}
                          sx={{
                            color: "#aaa",
                            "&.Mui-checked": {
                              color: "#ADB792",
                            },
                          }}
                        />
                      }
                      label={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${option.value?.replace(/<\/?p>/g, "")} `,
                          }}
                          style={{ fontSize: "14px" }}
                        />
                      }
                      sx={{
                        margin: 0,
                        width: "100%",
                      }}
                    />
                  </Box>
                ))}
            </Box>
            {validationErrors.some(
              (e) => e.field === `question_${question.questionId}`
            ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
              <FieldError
                errors={validationErrors}
                field={`question_${question.questionId}`}
              />
            </Box>)}
          </FormControl>
        )}

        {/* Comment section */}
        {/* {question.qType === "R" &&
          options.find((opt: any) => opt.value === responseData.value)
            ?.optionComment == "yes" && (
            <Box sx={{ mt: 2 }}>
              <FormLabel
                sx={{
                  fontSize: "14px",
                  color: "#666",
                  mb: 1,
                  display: "block",
                }}
              >
                Add your Comment<span style={{ color: "#D32F2F" }}> *</span>
              </FormLabel>
              <TextareaAutosize
                data-field={`question_${question.questionId}_comment`}
                minRows={3}
                placeholder="Write here..."
                value={responseData.comment}
                onChange={(e) => handleCommentChange(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                  backgroundColor: "#fff",
                  resize: "vertical",
                  //minHeight: "100px",
                  borderColor: validationErrors.some(
                    (e) => e.field === `comment_${question.questionId}`
                  )
                    ? "#d32f2f"
                    : "#ddd",
                }}
              />
              <FieldError
                errors={validationErrors}
                field={`question_${question.questionId}_comment`}
              />
            </Box>
          )} */}
        {((question.qType === "R" || question.qType === "r") || showcommentbox) &&
          (() => {
            const selectedOption: any = options.find(
              (opt: any) => opt.value.trim() === responseData.value.trim()
            );
            if ((selectedOption?.optionComment)?.toLowerCase() !== "yes" && showcommentbox === false && !isAdmin) return null;
            // if(isAdmin && localComment?.length < 1 && !showcommentbox && selectedOption?.optionComment)?.toLowerCase() !== "yes") return null
            const commentType = selectedOption?.optionCommentType || "text";
            const commentLabel =
              `${selectedOption?.optionCommentLabel ?? 'Enter your comment'} (minimum ${selectedOption?.minChar ?? 0} words is required)` || `Add your Comment (minimum ${selectedOption?.minChar ?? 0} words is required)`;

            if (isAdmin && (responseData?.comment?.length > 1 || showcommentbox || (selectedOption?.optionComment)?.toLowerCase() == "yes")) {
              return (
                <Box sx={{ mt: 2 }}>
                  {["text", "longText"].includes(commentType) && (
                    <>
                      <FormLabel
                        sx={{
                          fontSize: "14px",
                          color: "#666",
                          mb: 1,
                          display: "block",

                        }}
                      >
                        {commentLabel}
                        <span style={{ color: "#D32F2F" }}> *</span>
                      </FormLabel>
                      <TextareaAutosize
                        data-field={`question_${question.questionId}_comment`}
                        minRows={3}
                        placeholder="Write here..."
                        value={localComment}
                        onChange={(e) => handleCommentChange(e.target.value)}
                        onBlur={(e) => {
                          const updateddata = {
                            reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                            platform: "web",
                            platformAppType: null,
                            reportDtlId: question.reportDtlId,
                            value: responseData.value,
                            questionId: responseData.questionId,
                            photoUrl: responseData.photoUrl,
                            score: responseData.score,
                            comment: e.target.value,
                            isAnswered: responseData.value !== "",
                          }
                          updateQuestion(updateddata)
                        }}
                        style={{
                          width: "100%",
                          padding: "12px",
                          borderRadius: "8px",
                          caretColor: "black",
                          border: "1px solid #ddd",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          resize: "vertical",
                          borderColor: validationErrors.some(
                            (e) => e.field === `question_${question.questionId}_comment`
                          )
                            ? "#d32f2f"
                            : "green",
                        }}

                      />
                      {validationErrors.some(
                        (e) => e.field === `question_${question.questionId}_comment`
                      ) && commentType && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                        <FieldError
                          errors={validationErrors}
                          field={`question_${question.questionId}_comment`}
                        />
                      </Box>)}
                    </>
                  )}

                  {commentType === "time" && (
                    <>
                      <FormLabel
                        sx={{
                          fontSize: "14px",
                          color: "#666",
                          mb: 1,
                          display: "block",
                        }}
                      >
                        {commentLabel}
                        <span style={{ color: "#D32F2F" }}> *</span>
                      </FormLabel>
                      <TextField
                        type="time"
                        fullWidth
                        value={responseData.comment || ""}
                        onChange={(e) => {
                          handleCommentChange(e.target.value)
                          const updateddata = {
                            reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                            platform: "web",
                            platformAppType: null,
                            reportDtlId: question.reportDtlId,
                            value: responseData.value,
                            questionId: responseData.questionId,
                            photoUrl: responseData.photoUrl,
                            score: responseData.score,
                            comment: e.target.value,
                            isAnswered: responseData.value !== "",
                          }
                          updateQuestion(updateddata)
                        }
                        }
                        error={validationErrors.some(
                          (e) => e.field === `comment_${question.questionId}`
                        )}
                        inputProps={{
                          step: 300, // 5-minute intervals
                        }}
                      />
                    </>
                  )}

                  {commentType === "checkbox" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={responseData.comment === "true"}
                          onChange={(e) => {
                            handleCommentChange(
                              e.target.checked ? "true" : "false"
                            )
                            const updateddata = {
                              reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                              platform: "web",
                              platformAppType: null,
                              reportDtlId: question.reportDtlId,
                              value: responseData.value,
                              questionId: responseData.questionId,
                              photoUrl: responseData.photoUrl,
                              score: responseData.score,
                              comment: e.target.checked ? "true" : "false",
                              isAnswered: responseData.value !== "",
                            }
                            updateQuestion(updateddata)
                          }
                          }
                          sx={{
                            color: "#aaa",
                            "&.Mui-checked": {
                              color: "#ADB792",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ fontSize: "14px" }}>
                          {commentLabel}
                          <span style={{ color: "#D32F2F" }}> *</span>
                        </Typography>
                      }
                    />
                  )}
                  {validationErrors.some(
                    (e) => e.field === `question_${question.questionId}`
                  ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                    <FieldError
                      errors={validationErrors}
                      field={`comment_${question.questionId}`}
                    />
                  </Box>)}
                </Box>
              );
            }
            else if (!isAdmin) {
              return (
                <Box sx={{ mt: 2 }}>
                  {["text", "longText"].includes(commentType) && (
                    <>
                      <FormLabel
                        sx={{
                          fontSize: "14px",
                          color: "#666",
                          mb: 1,
                          display: "block",

                        }}
                      >
                        {commentLabel}
                        <span style={{ color: "#D32F2F" }}> *</span>
                      </FormLabel>
                      <TextareaAutosize
                        data-field={`question_${question.questionId}_comment`}
                        minRows={3}
                        placeholder="Write here..."
                        value={localComment}
                        onChange={(e) => handleCommentChange(e.target.value)}
                        onBlur={(e) => {
                          const updateddata = {
                            reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                            platform: "web",
                            platformAppType: null,
                            reportDtlId: question.reportDtlId,
                            value: responseData.value,
                            questionId: responseData.questionId,
                            photoUrl: responseData.photoUrl,
                            score: responseData.score,
                            comment: e.target.value,
                            isAnswered: responseData.value !== "",
                          }
                          updateQuestion(updateddata)
                        }}
                        style={{
                          width: "100%",
                          padding: "12px",
                          borderRadius: "8px",
                          caretColor: "black",
                          border: "1px solid #ddd",
                          fontSize: "14px",
                          backgroundColor: "#fff",
                          resize: "vertical",
                          borderColor: validationErrors.some(
                            (e) => e.field === `question_${question.questionId}_comment`
                          )
                            ? "#d32f2f"
                            : "green",
                        }}

                      />
                      <MicButton
                        onClick={() => setVoiceTarget("comment")}
                        sx={{ position: "absolute", top: isAdmin ? 30 : 8, right: 8 }}
                      />
                      {validationErrors.some(
                        (e) => e.field === `question_${question.questionId}_comment`
                      ) && commentType && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                        <FieldError
                          errors={validationErrors}
                          field={`question_${question.questionId}_comment`}
                        />
                      </Box>)}
                    </>
                  )}

                  {commentType === "time" && (
                    <>
                      <FormLabel
                        sx={{
                          fontSize: "14px",
                          color: "#666",
                          mb: 1,
                          display: "block",
                        }}
                      >
                        {commentLabel}
                        <span style={{ color: "#D32F2F" }}> *</span>
                      </FormLabel>
                      <TextField
                        type="time"
                        fullWidth
                        value={responseData.comment || ""}
                        onChange={(e) => {
                          handleCommentChange(e.target.value)
                          const updateddata = {
                            reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                            platform: "web",
                            platformAppType: null,
                            reportDtlId: question.reportDtlId,
                            value: responseData.value,
                            questionId: responseData.questionId,
                            photoUrl: responseData.photoUrl,
                            score: responseData.score,
                            comment: e.target.value,
                            isAnswered: responseData.value !== "",
                          }
                          updateQuestion(updateddata)
                        }
                        }
                        error={validationErrors.some(
                          (e) => e.field === `comment_${question.questionId}`
                        )}
                        inputProps={{
                          step: 300, // 5-minute intervals
                        }}
                      />
                    </>
                  )}

                  {commentType === "checkbox" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={responseData.comment === "true"}
                          onChange={(e) => {
                            handleCommentChange(
                              e.target.checked ? "true" : "false"
                            )
                            const updateddata = {
                              reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                              platform: "web",
                              platformAppType: null,
                              reportDtlId: question.reportDtlId,
                              value: responseData.value,
                              questionId: responseData.questionId,
                              photoUrl: responseData.photoUrl,
                              score: responseData.score,
                              comment: e.target.checked ? "true" : "false",
                              isAnswered: responseData.value !== "",
                            }
                            updateQuestion(updateddata)
                          }
                          }
                          sx={{
                            color: "#aaa",
                            "&.Mui-checked": {
                              color: "#ADB792",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography sx={{ fontSize: "14px" }}>
                          {commentLabel}
                          <span style={{ color: "#D32F2F" }}> *</span>
                        </Typography>
                      }
                    />
                  )}
                  {validationErrors.some(
                    (e) => e.field === `question_${question.questionId}`
                  ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                    <FieldError
                      errors={validationErrors}
                      field={`comment_${question.questionId}`}
                    />
                  </Box>)}
                </Box>
              );
            }

          })()}

        {isAdmin && (responseData?.comment?.length > 1 && !showcommentbox && question.qType !== "r" && question.qType !== "R") &&
          (
            <Box sx={{ mt: 2 }}>
              <>
                <FormLabel
                  sx={{
                    fontSize: "14px",
                    color: "#666",
                    mb: 1,
                    display: "block",

                  }}
                >
                  {/* {commentLabel} */}
                  Enter your comment
                  <span style={{ color: "#D32F2F" }}> *</span>
                </FormLabel>
                <TextareaAutosize
                  data-field={`question_${question.questionId}_comment`}
                  minRows={3}
                  placeholder="Write here..."
                  value={localComment}
                  onChange={(e) => handleCommentChange(e.target.value)}
                  onBlur={(e) => {
                    const updateddata = {
                      reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                      platform: "web",
                      platformAppType: null,
                      reportDtlId: question.reportDtlId,
                      value: responseData.value,
                      questionId: responseData.questionId,
                      photoUrl: responseData.photoUrl,
                      score: responseData.score,
                      comment: e.target.value,
                      isAnswered: responseData.value !== "",
                    }
                    updateQuestion(updateddata)
                  }}
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    caretColor: "black",
                    border: "1px solid #ddd",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                    resize: "vertical",
                    borderColor: validationErrors.some(
                      (e) => e.field === `question_${question.questionId}_comment`
                    )
                      ? "#d32f2f"
                      : "green",
                  }}

                />
                <MicButton
                  onClick={() => setVoiceTarget("comment")}
                  sx={{ position: "absolute", top: isAdmin ? 30 : 8, right: 8 }}
                />
              </>
              {validationErrors.some(
                (e) => e.field === `question_${question.questionId}`
              ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                <FieldError
                  errors={validationErrors}
                  field={`comment_${question.questionId}`}
                />
              </Box>)}
            </Box>
          )
        }

        {/* Image upload validation message */}
        {(((responseData.optionImage > 0) || showimagebox) &&
          !validateImageUploads(
            responseData?.optionImage,
            uploadedFiles?.questionFiles[question.questionId]
          )) && (
            <Alert severity="error" sx={{ mt: 2, mb: 1 }}>
              {getImageValidationMessage(responseData.optionImage)}
            </Alert>
          )}
        {/* {((question.isPhotoRequire === 1) && !validateImageUploads(
          question.isPhotoRequire,
          uploadedFiles.questionFiles[question.questionId]
        )) && (
            <Alert severity="error" sx={{ mt: 2, mb: 1 }}>
              {getImageValidationMessage(question.isPhotoRequire)}
            </Alert>
          )} */}

        {/* Photo upload section */}
        {(responseData.optionImage > 0 ||
          question.isPhotoRequire === 1 || showimagebox ||
          responseData.photoUrl !== "") && (
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="body2"
                sx={{
                  color: "#666",
                  mb: 1,
                  fontSize: "14px",
                }}
              >
                Upload Image{" "}
                {(responseData.optionImage > 0)
                  ? `(minimum ${responseData.optionImage} images required)*`
                  : question.isPhotoRequire === 1 ? `(minimum ${question.minPhoto} images required)*` : ''}
              </Typography>

              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                <FileUpload
                  data-field={`question_${question.questionId}_images`}
                  section="questionFiles"
                  title=""
                  questionId={question.questionId}
                  clientGroup={clientGroup}
                  reportDetailId={question.reportDtlId}
                  setUploadedFiles={setUploadedFiles}
                  reorderFile={reorderFile}
                  files={
                    (answers[question.questionId]?.photoUrl || "")
                      .split(",")
                      .map((str) => str.trim())
                      .filter(Boolean) ||
                    (question.photoUrl || "")
                      .split(",")
                      .map((str) => str.trim())
                      .filter(Boolean) ||
                    []
                  }
                  setArchieveImages={setArchieveImages}
                  onUpload={onFileUpload}
                  onUpdate={onFileUpdate}
                  // onUpload={(event: React.ChangeEvent<HTMLInputElement>) => {
                  //   const files = event.target.files;
                  //   if (!files || files.length === 0) return;

                  //   const file = files[0]; // pick the first file
                  //   setCropperFile(file);
                  //   setCropperOpen(true);
                  // }}
                  onRemove={onRemoveFile}
                />
              </Box>
              {validationErrors.some(
                (e) => e.field === `question_${question.questionId}_images`
              ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className='d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
                <FieldError
                  errors={validationErrors}
                  field={`question_${question.questionId}_images`}
                />
              </Box>)}
              {/* {cropperOpen && cropperFile && (
                <CropperModal
                  file={cropperFile}
                  onClose={() => setCropperOpen(false)}
                  onSave={(croppedFile) => {
                    onFileUpload(
                      { target: { files: [croppedFile] } } as unknown as React.ChangeEvent<HTMLInputElement>,
                      "questionFiles",
                      question.questionId,
                      question.reportDtlId

                    );
                    setCropperOpen(false);
                  }}
                />
              )} */}
            </Box>
          )}

        {validationErrors.some(
          (e) => e.field === `question_${question.questionId}_score`
        ) && (<Box bgcolor={'red'} p={1} borderRadius='10px' className=' mt-2 d-flex align-items-center gap-2 text-error'><ReportProblemOutlined sx={{ fill: 'white !important' }} />
          <FieldError
            errors={validationErrors}
            field={`question_${question.questionId}_score`}
          />
        </Box>)}
      </Box>
      <Box className="scoreDisplay" width={{ xs: '100%', md: "auto" }} sx={{ float: { xs: "left", md: "right" } }}>
        <Box
          sx={{
            width: { xs: '100%', md: 120 },
            marginTop: { xs: "20px", md: '0px' },
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          }}
        >
          {question.oldMaxScore === 0 || responseData.score == -1 ? (
            // === Non-Scoring Box ===
            <Box
              sx={{
                backgroundColor: "#ccc",
                width: "100%",
                height: "100%",
                minHeight: "100px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "12px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#000",
                  textAlign: "center",
                  lineHeight: 1.3,
                }}
              >
                Non
                <br />
                Scoring
              </Typography>
            </Box>
          ) : (
            // === Scoring Box ===
            <>
              {/* Top Section */}
              <Box
                sx={{
                  backgroundColor: "#BF613B",
                  p: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#fff",
                    mb: 0.5,
                  }}
                >
                  Add Score
                </Typography>
                <TextField
                  data-field={`question_${question.questionId}_score`}

                  variant="outlined"
                  size="small"
                  value={responseData.score !== null ? responseData.score : ''}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    // if (value.length > 3) value = value.slice(0, 3);

                    // setResponseData((prevData) => ({
                    //   ...prevData,
                    //   score: value ? Number(value) : null,
                    // }));
                    let numericValue = Number(value);

                    // ✅ clamp value to maxScore
                    const maxScore = parseInt(question.maxScore, 10) || 0;
                    if (numericValue > maxScore) {
                      numericValue = maxScore;
                    }

                    setResponseData((prevData) => ({
                      ...prevData,
                      score: value === "" ? null : Number(value),
                    }));

                    onAnswerChange(question.questionId, {
                      reportDtlId: question.reportDtlId,
                      questionId: question.questionId,
                      value: responseData.value,
                      photoUrl: responseData.photoUrl,
                      score: value === "" ? null : Number(value),
                      comment: responseData.comment,
                      isAnswered: e.target.value.length > 0,
                    });
                  }}
                  onBlur={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    const updateddata = {
                      reportHeaderId: questionsData?.reportHeader?.reportHeaderId,
                      platform: "web",
                      platformAppType: null,
                      reportDtlId: question.reportDtlId,
                      value: responseData.value,
                      questionId: responseData.questionId,
                      photoUrl: responseData.photoUrl,
                      score: value === "" ? null : Number(value),
                      comment: responseData.comment,
                      isAnswered: e.target.value.length > 0,
                    }
                    updateQuestion(updateddata)
                  }}
                  disabled={question.qType !== "T" && String(responseData.value)?.trim()?.toLowerCase() !== "other" && String(responseData.value)?.trim()?.toLowerCase() !== "other (please specify)" && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem("liveuserRole") !== 'clientadmin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor'}
                  inputProps={{
                    type: "text",
                    // min: 0,
                    max: parseInt(question.maxScore),
                    // maxLength: 4,
                    style: {
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#000",
                      padding: "6px 8px",
                    },
                  }}
                  sx={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                      height: "40px",
                      "& fieldset": {
                        borderColor: "#ccc",
                        borderRadius: "8px",
                      },

                    },
                    borderColor: validationErrors.some(
                      (e) => e.field === `question_${question.questionId}_score`
                    )
                      ? "#d32f2f"
                      : "green",
                  }}
                />
              </Box>

              {/* Divider */}
              <Box sx={{ height: "2px", backgroundColor: "#fff" }} />

              {/* Bottom Section */}
              <Box
                className='bg-third'
                sx={{
                  // backgroundColor: "#D4DBC2",
                  textAlign: "center",
                  py: 0.75,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "#fff",
                  }}
                >
                  out of {question.oldMaxScore}
                </Typography>
              </Box>

              {((responseData?.score < question.oldMaxScore) && (localStorage.getItem('liveuserRole') === 'admin' || localStorage.getItem('liveuserRole') === 'superadmin' || localStorage.getItem("liveuserRole") === 'editor')) && (<Box sx={{ background: "green" }} className='d-flex justify-content-center py-1'>
                <Typography
                  variant="caption"
                  className="text-center w-100"
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#fff",
                  }}
                >
                  CheckScore
                </Typography>
              </Box>
              )}
              {(() => {
                const selectedOption = options.find(
                  (opt: any) => opt.value.trim() === responseData.value.trim()
                );

                const role = localStorage.getItem("liveuserRole");

                if (
                  responseData?.score !== selectedOption?.optionScore && responseData?.value && options?.length > 0 &&
                  (role === "admin" || role === "superadmin" || role === "editor")
                ) {
                  return (
                    <Box
                      sx={{ background: "yellow" }}
                      className="d-flex justify-content-center p-1"
                    >
                      <Typography
                        className="text-center w-100"
                        sx={{
                          fontSize: "16px",
                          fontWeight: 700,
                          color: "black",
                        }}
                      >
                        SC: {selectedOption?.optionScore}
                      </Typography>
                    </Box>
                  );
                }

                return null;
              })()}

            </>
          )}

        </Box>

      </Box>

      <Dialog sx={{ "& .MuiDialog-paper": { background: 'transparent !important' } }} open={bigImg} onClose={() => { setbigImg(false) }}>
        <DialogContent style={{ height: '70vh', maxWidth: "100%", backgroundColor: 'transparent !important' }}>
          <Box position='relative' sx={{
            maxHeight: 'calc(50vh - 100px) !important',

            // backgroundColor: 'green',
            '.image-gallery-center': {
              backgroundColor: 'transparent',
              maxHeight: 'calc(100vh - 180px)!important',
            },
            '.image-gallery-svg': {
              color: '#ADB792'
            }
          }}>
            <IconButton
              onClick={() => setbigImg(false)}
              sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, }}
            >
              <CloseOutlined sx={{ fontSize: '48px' }} />
            </IconButton>
            <ImageGallery items={images} showPlayButton={false} />
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={openHistory} sx={{ maxWidth: "800px", mx: 'auto' }}>
        <Box className='d-flex mb-3 px-3 pt-3 bg-white w-100 align-items-center justify-content-between' position={'sticky'} top={0}>
          <Typography variant="h5" className="fw-bold">History</Typography>
          <IconButton onClick={() => { setReportHistory(null); setOpenHistory(false) }}>
            <CancelOutlined />
          </IconButton>
        </Box>
        <DialogContent>
          {resportHistory?.sort((a: any, b: any) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
            ?.map((item: any, index: number) => {
              // const localDate = new Date(item?.createdOn.replace(" ", "T") + "Z");
              const date = new Date(item?.createdOn + " GMT+1100");
              const local = date.toLocaleString();
              const handleCopy = (text: string, index: number) => {
                navigator?.clipboard?.writeText(text);
                setCopiedIndex(index);

                setTimeout(() => {
                  setCopiedIndex(null);
                }, 1500);
              };
              return (
                <Box className='pb-2 mb-3' borderBottom={'1px dashed #ccc'}>
                  <Box className='d-flex w-100 mb-1 justify-content-end'>
                    <Typography className="fw-bold" variant="caption">{local.toLocaleString()} ({item?.email})</Typography>
                  </Box>
                  <Box className='d-flex align-items-start mb-1' gap={1}>
                    <Typography variant="body2" className="fw-bold" flex={1}>{item?.value}</Typography>
                    <Tooltip title={copiedIndex === index ? "Copied" : "Copy"}>
                      <IconButton
                        size="small"
                        onClick={() => handleCopy(item?.value, index)}
                      >
                        <ContentCopyOutlined fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {item?.comment && (<Box className='d-flex align-items-start mb-1' gap={1}>
                    <Typography variant="body2" flex={1}><b>Comment: </b>{item?.comment}</Typography>
                    <Tooltip title={copiedIndex === index ? "Copied" : "Copy"}>
                      <IconButton
                        size="small"
                        onClick={() => handleCopy(item?.comment, index)}
                      >
                        <ContentCopyOutlined fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  )}
                  <Box className='d-flex align-items-start mb-1' gap={1}>
                    <Typography variant="body2" flex={1}><b>Score: </b>{item?.score}</Typography>
                    <Tooltip title={copiedIndex === index ? "Copied" : "Copy"}>
                      <IconButton
                        size="small"
                        onClick={() => handleCopy(item?.score, index)}
                      >
                        <ContentCopyOutlined fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              )
            })}
        </DialogContent>
      </Dialog>

      <VoiceInputDialog
        open={voiceTarget !== null}
        title={voiceTarget === "comment" ? "Speak your comment" : "Speak your answer"}
        initialText={voiceTarget === "comment" ? localComment : localValue}
        onClose={() => setVoiceTarget(null)}
        clientGroup={clientGroup}
        onDone={(text) => voiceTarget && applyVoiceText(voiceTarget, text)}
      />
    </Paper>
  );
};

export default ALDIQuestionItem;
